import {makeGetContractualTermLink} from 'main/factories/usecases/private/remote-home/get-contractual-term-link-factory';

export const getContractualTermLink = () => makeGetContractualTermLink().get();
